exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@700;900&display=swap);", ""]);

// module
exports.push([module.id, "\n/* animated gradient BG */\n.gradient-bg[data-v-d154ed7c] {\n  background: linear-gradient(-45deg, #6f36bc, #ff4778, #6d28d9, #db2777);\n  background-size: 400% 400%;\n  animation: gradient-d154ed7c 10s ease infinite;\n}\n@keyframes gradient-d154ed7c {\n0% {\n    background-position: 0% 50%;\n}\n50% {\n    background-position: 100% 50%;\n}\n100% {\n    background-position: 0% 50%;\n}\n}\n", ""]);

// exports
